import { Gem } from "lucide-react";
import { LANDING } from "@/constants/testIds";
import { t } from "@/lib/i18n";
import { DrawCard } from "@/components/landing/PromoCards";

// Exclusive Draw section — three prize cards. drawRef is attached here so the
// parent's IntersectionObserver can fire the draw_section_view analytics event.
export default function DrawSection({ drawRef, lang, config, millenniumImg, luxuryCarImg, motorcycleImg }) {
  return (
    <section className="ddf-section ddf-draw-section" ref={drawRef}>
      <h2 className="ddf-section-title ddf-section-title--centered ddf-section-title--draw ddf-section-title--edge">
        <Gem size={22} style={{ marginRight: 10 }} />
        {t(lang, "win_with_ddf")}
      </h2>
      <div className="ddf-draw-grid">
        <DrawCard
          title={t(lang, "millennium")}
          subtitle={t(lang, "millennium_sub")}
          image={millenniumImg}
          link={config.millenniumLink}
          testId={LANDING.drawCardMillennium}
          bgColor="#222"
          entry="millennium"
        />
        <DrawCard
          title={t(lang, "finest_surprise")}
          subtitle={t(lang, "win_luxury_car")}
          image={luxuryCarImg}
          link={config.luxuryCarLink}
          testId={LANDING.drawCardLuxury}
          bgColor="#f5e7b3"
          entry="luxury_car"
        />
        <DrawCard
          title={t(lang, "finest_surprise")}
          subtitle={t(lang, "win_motorcycle")}
          image={motorcycleImg}
          link={config.motorcycleLink}
          testId={LANDING.drawCardMotorcycle}
          bgColor="#cfe6ff"
          entry="motorcycle"
        />
      </div>
    </section>
  );
}
